/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DragHandleIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  (props, ref) => {
    return (
      <BaseIcon {...props} ref={ref}>
        <svg
          data-wf-icon="DragHandleIcon"
          width="5"
          height="24"
          viewBox="0 0 5 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <mask id="path-1-inside-1_25_20288" fill="white">
                <path d="M1 9H4V8H1V9ZM1 13H4V12H1V13ZM1 17H4V16H1V17Z" />
              </mask>
              <path
                d="M1 9H4V8H1V9ZM1 13H4V12H1V13ZM1 17H4V16H1V17Z"
                fill="currentColor"
                stroke="currentColor"
              />
              <path
                d="M1 9H0V10H1V9ZM4 9V10H5V9H4ZM4 8H5V7H4V8ZM1 8V7H0V8H1ZM1 13H0V14H1V13ZM4 13V14H5V13H4ZM4 12H5V11H4V12ZM1 12V11H0V12H1ZM1 17H0V18H1V17ZM4 17V18H5V17H4ZM4 16H5V15H4V16ZM1 16V15H0V16H1ZM1 10H4V8H1V10ZM5 9V8H3V9H5ZM4 7H1V9H4V7ZM0 8V9H2V8H0ZM1 14H4V12H1V14ZM5 13V12H3V13H5ZM4 11H1V13H4V11ZM0 12V13H2V12H0ZM1 18H4V16H1V18ZM5 17V16H3V17H5ZM4 15H1V17H4V15ZM0 16V17H2V16H0Z"
                fill="currentColor"
                mask="url(#path-1-inside-1_25_20288)"
                stroke="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

DragHandleIcon.category = 'Misc.';
